import { useState } from 'react';
import { saveConsent } from './utils/cookieConsent';
import '../css/CookieConsent.css';

export default function CookieBanner({ onClose }) {
    const [customizing, setCustomizing] = useState(false);

    function choose(choice) {
        saveConsent(choice);
        onClose();
    }

    const reject = () => choose({ externalServices: false });

    return (
        <section className="ef-cookie-banner" aria-labelledby="ef-cookie-title" onKeyDown={event => {
            if (event.key === 'Escape') { event.stopPropagation(); reject(); }
        }}>
            <div className="ef-cookie-banner__inner">
                <button type="button" className="ef-cookie-banner__close" aria-label="Chiudi e rifiuta i servizi facoltativi" onClick={reject}>×</button>
                <h2 id="ef-cookie-title">La tua privacy, le tue scelte</h2>
                <p>Usiamo memorie tecniche per accesso, preferiti e ricerche. Google Maps fornisce i suggerimenti degli indirizzi anche se rifiuti i cookie facoltativi: Google riceve i dati tecnici della connessione e il testo cercato. Consulta le informative per i dettagli.</p>
                <p>I click sono conteggiati internamente in forma aggregata, senza cookie statistici o identificatori dei visitatori, indipendentemente da questa scelta.</p>
                <p><a href="/cookie-policy">Cookie Policy</a> · <a href="/privacy-policy">Informativa privacy</a></p>

                {customizing && <fieldset className="ef-cookie-banner__preferences">
                    <legend>Scegli quali servizi attivare</legend>
                    <p>Le memorie tecniche sono sempre attive e non richiedono consenso.</p>
                    <p>Google Maps è integrato nelle funzioni di ricerca e indirizzo e non viene disattivato dalle preferenze cookie. Non sono attualmente presenti servizi facoltativi da attivare.</p>
                </fieldset>}

                <div className="ef-cookie-banner__actions">
                    <button type="button" className="ef-cookie-banner__action" onClick={reject}>Rifiuta facoltativi</button>
                    {customizing
                        ? <button type="button" className="ef-cookie-banner__action" onClick={() => choose({ externalServices: false })}>Salva preferenze</button>
                        : <button type="button" className="ef-cookie-banner__action" onClick={() => setCustomizing(true)}>Personalizza</button>}
                    <button type="button" className="ef-cookie-banner__action" onClick={() => choose({ externalServices: true })}>Accetta tutti</button>
                </div>
            </div>
        </section>
    );
}
